import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HostService} from '@app/core/global/host.service';
import {environment} from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private bundle = new BehaviorSubject(null);

    constructor(
        private http: HttpClient,
        private hostService: HostService
    ) {
        this.loadBundle(this.getActiveThemeName())
            .subscribe(bundle => {
                this.bundle.next(bundle);
            });
    }

    public getActiveThemeName() {
        const hostName = this.hostService.getHostname();
        let theme = environment.customer.theme;
        let themeSuffix = 'master';

        if ((hostName === 'lightspeed.gg4l.com') || (hostName === 'lightspeed.edutone.net')) {
            theme = 'lightspeed';
            themeSuffix = 'master';
        }

        return theme + '-' + themeSuffix;
    }

    public getBundle() {
        return this.bundle.asObservable();
    }

    public loadBundle(theme: string): Observable<Object> {
        // return this.http.get(`./assets/themes/${theme}/bundle.json`);
        return this.http.get(`./bundle.json`);
    }

    getBundleValue(key: string): any {
        return this.getValueOfTarget(this.bundle.getValue(), key);
    }

    public getValueOfTarget(target: any, key: string): any {
        if (!target) {
            return key;
        }
        const keys = key.split('.');
        key = '';
        do {
            key += keys.shift();
            if (this.isDefined(target) && this.isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
                target = target[key];
                key = '';
            } else if (!keys.length) {
                target = undefined;
            } else {
                key += '.';
            }
        } while (keys.length);

        return target;
    }

    private isDefined(obj) {
        return !!obj;
    }
}
